import React from "react";
import profilePhoto from "../img/pfp.jpeg";

function HomeHero() {
  return (
    <section id="home" className="lp-hero">
      {/* Layer di forme geometriche animate */}
      <div className="lp-shapes-layer">
        {/* Cerchi pieni grandi */}
        <div className="shape-circle shape-circle-1" />
        <div className="shape-circle shape-circle-2" />
        <div className="shape-circle shape-circle-3" />

        {/* Ellissi outline */}
        <div className="shape-ellipse shape-ellipse-1" />
        <div className="shape-ellipse shape-ellipse-2" />
        <div className="shape-ellipse shape-ellipse-3" />

        {/* Forme organiche arrotondate */}
        <div className="shape-rounded shape-rounded-1" />
        <div className="shape-rounded shape-rounded-2" />

        {/* Piccoli accenti circolari */}
        <div className="shape-dot shape-dot-1" />
        <div className="shape-dot shape-dot-2" />
        <div className="shape-dot shape-dot-3" />
      </div>

      {/* Contenuto principale */}
      <div className="lp-hero-inner">
        {/* Colonna sinistra: solo foto */}
        <div className="lp-left">
          <div className="lp-profile-photo">
            <img 
              src={profilePhoto} 
              alt="Enrico Cuomo" 
              className="lp-photo-img"
            />
          </div>
        </div>

        {/* Colonna destra: nome + testo + contatti */}
        <div className="lp-right">
          <h1 className="lp-title">Enrico Cuomo</h1>
          <p className="lp-text">Digital Innovation | Product & Strategy</p>
          <p className="lp-text"><i>Technology · Business · Creativity</i></p>
          <div className="lp-links">
            <span className="lp-link">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="lp-icon bi bi-telephone-fill" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"/>
              </svg>
              +39 3884807703
            </span>
            <a href="mailto:enricocuomo9@gmail.com" className="lp-link">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="lp-icon bi bi-envelope-fill" viewBox="0 0 16 16">
                <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414zM0 4.697v7.104l5.803-3.558zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586zm3.436-.586L16 11.801V4.697z"/>
              </svg>    
              enricocuomo9@gmail.com
            </a>
            {/* <span> */}
              <a href="https://www.linkedin.com/in/enrico-cuomo/" className="lp-link" target="_blank" rel="noopener noreferrer">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="lp-icon bi bi-linkedin" viewBox="0 0 16 16">
                  <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z"/>
                </svg>
                Enrico Cuomo
              </a>
            {/* </span> */}
            <a href="https://drive.google.com/drive/folders/1oKtXlNWBxqUTaFiKMNMJDgyDG4rOAcVZ?usp=sharing" className="lp-linka" target="_blank" rel="noopener noreferrer">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="lp-icon bi bi-file-earmark-person-fill" viewBox="0 0 16 16">
                <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0M9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0m2 5.755V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-.245S4 12 8 12s5 1.755 5 1.755"/>
              </svg>
              CV
            </a>
          </div>
        </div>

        </div>
    </section>
  );
}

export default HomeHero;
